import { StyleSheet } from 'react-native';
import { LI } from '@expo/html-elements';
import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsNutritionEntriesDivider = () => {
  return <LI style={styles.divider} />;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  divider: {
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.LIGHT,
  },
});
